import { ALERT_OPEN, ALERT_CLOSE } from "../action-types/alertActionType"


export default function alertOpen(data: any) {
    return {
        type: ALERT_OPEN,
        payload: data
    }
}

export function alertClose(data: any) {
    return {
        type: ALERT_CLOSE,
        payload: data
    }
}